import { render, staticRenderFns } from "./BoxMenu.vue?vue&type=template&id=9518afc0&scoped=true&"
import script from "./BoxMenu.vue?vue&type=script&lang=js&"
export * from "./BoxMenu.vue?vue&type=script&lang=js&"
import style0 from "./BoxMenu.vue?vue&type=style&index=0&id=9518afc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9518afc0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
